(function () {
  var KEY = 'ks_cookie_consent_v1';
  var GRANTED = {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted',
  };
  var DENIED = {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  };

  function hide(root) {
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
  }

  function gtagConsent(state) {
    try {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('consent', 'update', state);
    } catch (e) {}
  }

  function setShopifyConsent(accepted) {
    function apply() {
      try {
        if (
          window.Shopify &&
          window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
        ) {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: accepted,
              marketing: accepted,
              preferences: accepted,
              sale_of_data: accepted,
            },
            function () {}
          );
        }
      } catch (e) {}
    }

    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            if (!error) apply();
            else apply();
          }
        );
        return;
      }
    } catch (e) {}
    apply();
  }

  function storedChoice() {
    try {
      return window.localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function applyStored() {
    var choice = storedChoice();
    if (choice === 'accepted') {
      gtagConsent(GRANTED);
      setShopifyConsent(true);
      return true;
    }
    if (choice === 'essential') {
      gtagConsent(DENIED);
      setShopifyConsent(false);
      return true;
    }
    gtagConsent(DENIED);
    setShopifyConsent(false);
    return false;
  }

  function bind(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    if (applyStored()) {
      hide(root);
      return;
    }

    root.querySelectorAll('[data-ks-consent]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var accepted = btn.getAttribute('data-ks-consent') === 'accept';
        try {
          window.localStorage.setItem(KEY, accepted ? 'accepted' : 'essential');
        } catch (e) {}
        if (accepted) gtagConsent(GRANTED);
        else gtagConsent(DENIED);
        setShopifyConsent(accepted);
        hide(root);
      });
    });
  }

  applyStored();
  document.querySelectorAll('kingdom-cookie-banner').forEach(bind);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('kingdom-cookie-banner').forEach(bind);
  });
})();
